import { render, staticRenderFns } from "./growthValue.vue?vue&type=template&id=0df7acd2&scoped=true"
import script from "./growthValue.vue?vue&type=script&lang=js"
export * from "./growthValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df7acd2",
  null
  
)

export default component.exports